import { Components } from '@material-ui/core/styles/components';

export const CommonThemeOverrides = {
    MuiCard: {
        styleOverrides: {
            root: {
                borderRadius: 8,
            },
        },
    },
    MuiButton: {
        styleOverrides: {
            root: {
                textTransform: 'none',
                borderRadius: 32,
            },
        },
        defaultProps: {
            variant: 'outlined',
        },
    },
    MuiButtonBase: {
        defaultProps: {
            disableRipple: true,
            disableTouchRipple: true,
        },
    },
    MuiGrid: {
        defaultProps: {
            spacing: 4,
        },
    },
    MuiFormControl: {
        defaultProps: {
            variant: 'outlined',
        },
    },
    MuiTextField: {
        defaultProps: {
            variant: 'outlined',
        },
    },
} as Components;
